export default "__VITE_ASSET__B836aum4__"